import React, { useState } from "react";

import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";

import Login from "./Login";
import Inicio from "./Inicio";
import Proceso from "./Proceso";
import Usuario from "./Usuario";
import Iniciativas from "./Iniciativas";
import Equipo from "./Equipo";
import NoMatch from "./NoMatch";
import Pregunta202 from "./Pregunta202";
import Pregunta203 from "./Pregunta203";
import Pregunta204 from "./Pregunta204";
import Pregunta205 from "./Pregunta205";
import Pregunta206 from "./Pregunta206";
import Pregunta208 from "./Pregunta208";

import InicioTest1 from "./InicioTest1";

import Evento from "./Evento";
import Header from "./Header";

import Reporte from "./Reporte";
import Reporte260521 from "./Reporte260521";
import FichaEvaluado from "./FichaEvaluado";
import SeleccionarProceso from "./SeleccionarProceso";
import Consentimiento from "./Consentimiento";

import Fin from "./Fin";

import Cierre from "./Cierre";

import Footer from "./Footer";

import ProtectedRoute from "./ProtectedRoute"; // Importa el nuevo archivo
import ErrorBoundary from "./ErrorBoundary";

const App = () => {
  document.title = "CMDIC Selección";

  return (
    <div>
      <BrowserRouter basename="/">
        <ErrorBoundary>
          <Header />

          <Routes>
          <Route path="/" element={<Login />} />
          <Route path="login" element={<Login />} />
          <Route element={<ProtectedRoute />}>
            <Route path="inicio" element={<Inicio />} />
            <Route path="iniciativas" element={<Iniciativas />} />
            <Route path="proceso" element={<Proceso />} />
            <Route path="usuario" element={<Usuario />} />
            <Route path="equipo" element={<Equipo />} />
            <Route path="*" element={<NoMatch />} />
            <Route path="evento" element={<Evento />} />
            <Route path="pregunta-202" element={<Pregunta202 />} />
            <Route path="pregunta-203" element={<Pregunta203 />} />
            <Route path="pregunta-204" element={<Pregunta204 />} />
            <Route path="pregunta-205" element={<Pregunta205 />} />
            <Route path="pregunta-206" element={<Pregunta206 />} />
            <Route path="pregunta-208" element={<Pregunta208 />} />

            <Route path="consentimiento" element={<Consentimiento />} />

            {/* Selector de procesos (admin, Retorno == 2). */}
            <Route
              path="seleccionar-proceso"
              element={<SeleccionarProceso />}
            />
            {/* Acceso directo a /reporte redirige al selector. */}
            <Route
              path="reporte"
              element={<Navigate to="/seleccionar-proceso" replace />}
            />
            {/* Reporte de calibración (251204) — componente inmutable, datos estáticos. */}
            <Route path="reporte/251204" element={<Reporte />} />
            {/* Reporte productivo (260521) — plantilla para procesos futuros. */}
            <Route path="reporte/260521" element={<Reporte260521 />} />
            {/* Ficha detallada por evaluado (perfil 3 / superadmin). */}
            <Route path="ficha/:idUsuario" element={<FichaEvaluado />} />

            <Route path="fin" element={<Fin />} />
            <Route path="cierre" element={<Cierre />} />
          </Route>
          </Routes>

          <br />
        </ErrorBoundary>
      </BrowserRouter>
    </div>
  );
};

export default App;
